import React, { useEffect, useRef, useState } from "react";
import Topbar from "../Topbar/Topbar";
import "./Recoverystyle.css";
import { MdDelete } from "react-icons/md";
import { Col, Container, Row } from "react-bootstrap";
import Map from '../images/mapicon.svg'
import {useNavigate, useParams} from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { useDownloadExcel } from "react-export-table-to-excel";
import { useSelector } from "react-redux";
const Recovery = () => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
   const permissions = useSelector((state) => state.permissions); // Adjust based on your reducer path
   const designation = useSelector((state) => state.designation);
   console.log(designation);
   
  const [recoveryDataFetch, setRecoveryDataFetch] = useState([]);
  console.log("Recovery Data:", recoveryDataFetch);
  
  const [recoveryDelete, setRecoveryDelete] = useState(false);
  const {id} = useParams();
  const navigate = useNavigate();

  const handleViewRecovery = (customerid, id) => {
    navigate(`/viewrecovery`, { state: { customerid, id } });
  };

  const [filters, setFilters] = useState({
    customerid: "",
    leadStatus: "",
    recoveryStartDate: "",
    customername: "",
    contactnum: "",
    address: "",
    location:"",
    area: "",
    recoverynotes: "",
    workStatus: "",
    expectedRenewalDate: "",
    delete: "",
  });
  // Filter the recovery data based on the filters state
  const filteredData = recoveryDataFetch.filter((recovery) => {
  return Object.keys(filters).every((key) => {
    if (!filters[key]) return true;
    
    // Handle date filtering
    if (key === "recoveryStartDate") {
      if (!recovery.createdDate) return false;
      const filterDate = new Date(filters[key]);
      const recoveryDate = new Date(recovery.createdDate);
      return (
        recoveryDate.getFullYear() === filterDate.getFullYear() &&
        recoveryDate.getMonth() === filterDate.getMonth() &&
        recoveryDate.getDate() === filterDate.getDate()
      );
    }
    
    // Handle location filtering
    if (key === "location") {
      const locationStr = recovery.location 
        ? `${recovery.location.latitude},${recovery.location.longitude}`
        : "";
      return locationStr.toLowerCase().includes(filters[key]);
    }
    
    // Handle nested properties
    if (key === "recoverynotes") {
      return String(recovery.recoveryleadStatus?.recoverynotes || "").toLowerCase().includes(filters[key]);
    }
    
    return String(recovery[key] || "").toLowerCase().includes(filters[key]);
  });
});

  const [columnVisibility, setColumnVisibility] = useState({
    createdDate: true,
    customerId: true,
    leadStatus: true,
    recoveryStartDate: true,
    customerName: true,
    contactNumber: true,
    address: true,
    location: true,
    area: true,
    notes: true,
    workStatus: true,
    expectedRenewalDate: true,
    delete: true,
  });
   const [recoveryCounts, setRecoveryCounts] = useState({});
    //useeffect for count  statistic
//     useEffect(() => {
//       axios.get(apiUrl + "recovery-view", {}).then((res) => {
//         console.log("Raw API response:", res.data);
    
//       const add_Recovery = Array.isArray(res.data) ? res.data : [res.data];
    
//         console.log("Parsed data (add_Recovery):", add_Recovery);
    
//         setRecoveryDataFetch(add_Recovery);

//       const counts = {
//   open: add_Recovery.filter((c) => c.leadStatus?.toLowerCase() === "open").length,
//   progress: add_Recovery.filter((c) => c.leadStatus?.toLowerCase() === "progress").length,
//  completed: add_Recovery.filter((c) => c.leadStatus?.toLowerCase() === "completed").length,
//   outOfStation: add_Recovery.filter((c) => c.leadStatus?.toLowerCase() === "outofstation").length,
//   notHandover: add_Recovery.filter((c) => c.leadStatus?.toLowerCase() === "nothandover").length,
//   notAvailable: add_Recovery.filter((c) => c.leadStatus?.toLowerCase() === "notavailable").length,
//   expectRenewal: add_Recovery.filter((c) => c.leadStatus?.toLowerCase() === "expectrenewal").length,
// };
    
//         console.log("Status Counts:", counts);
    
//         setStatusCounts(counts);
//       });
//     }, [recoveryDelete, apiUrl]);
useEffect(() => {
  axios.get(apiUrl + "recovery-view")
    .then((res) => {
      console.log("Raw API response:", res.data);

      const add_Recovery = Array.isArray(res.data) ? res.data : [res.data];
      setRecoveryDataFetch(add_Recovery);

    })
    .catch((err) => {
      console.error("Error fetching recovery data:", err);
    });
}, [recoveryDelete, apiUrl]);

    
//Export PopUp
 const tableRef = useRef(null);
 const {onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Recovery_data",
    sheet: "Recovery",
  });
  const [shouldExport, setShouldExport] = useState(false);
  
    const handleExportConfirmation = () => {
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to export the Recovery details?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, export it!",
        cancelButtonText: "No, cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          onDownload();
          setShouldExport(true); // Allow the export to proceed
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire("Cancelled", "The export operation was cancelled.", "error");
          setShouldExport(false);
        }
      });
    };
  const [recoverySetting, setRecoverySetting] = useState(false);
  
  const recoverysettingPopup = (e) => {
    e.preventDefault();
    setRecoverySetting(!recoverySetting);
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value.toLowerCase(),
    }));
  };

  const handleColumnVisibilityChange = (e) => {
    const { name, checked } = e.target;
    setColumnVisibility((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const changedata = (data) => {
    const mappings = {
      customerid: "Customer Id",
      leadStatus: "Recovery Status",
      recoveryStartDate: "Recover Start Date",
      customerName: "Customer Name",
      contactNumber: "Contact Number",
      address: "Address",
      location: "Location",
      area: "Area",
      notes: "Notes",
      workStatus: "Work Status",
      expectedRenewalDate: "Expected Renewal Date",
      delete: "Delete",
    };
    return mappings[data] || data;
  };

  const navAddRecovery = () => {
    navigate('/addrecovery');
  };

  const recoveryHandleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "you want to delete this data!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(`${apiUrl}recovery-delete/${id}`);
        await Swal.fire("Deleted!", "Deleted Successfully.", "success");
        setRecoveryDelete(!recoveryDelete);
      } catch (error) {
        Swal.fire("Error!", "Something went wrong while deleting.", "error");
        console.error("Delete Error:", error);
      }
    }
  };

  useEffect(() => {
    const fetchRecoveryData = async () => {
      try {
        const response = await axios.get(`${apiUrl}recovery-view`);
        setRecoveryDataFetch(response.data);
      } catch (error) {
        console.error("Error fetching recovery data:", error);
      }
    };

    fetchRecoveryData();
  }, [recoveryDelete, apiUrl]);

  const formatDateTime = (customDate) => {
    if (!customDate) return "Invalid Date";
    
    // Handle both date string and Date object
    let dateStr = customDate;
    if (customDate instanceof Date) {
      const day = String(customDate.getDate()).padStart(2, '0');
      const month = String(customDate.getMonth() + 1).padStart(2, '0');
      const year = customDate.getFullYear();
      dateStr = `${day}-${month}-${year}`;
    }

    const isValidFormat = /^\d{2}-\d{2}-\d{4}$/.test(dateStr);
    if (!isValidFormat) return "Invalid Date";

    const [day, month, year] = dateStr.split("-");
    const now = new Date();
    let hours = now.getHours();
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    const time = `${hours}.${minutes} ${ampm}`;
    return `${day}-${month}-${year} / ${time}`;
  };

  const getReoveryStatusClass = (status) => {
    if (!status) return "";
    switch (status.toLowerCase().trim()) {
      case "open":
        return "device-open";
         case "collected":
        return "device-completed";
        case "progress":
        return "device-progress";
         case "not available":
        return "device-notavailable";
         case "expect renewal":
        return "device-expectrenewal";
         case "out of station":
        return "device-outofstation";
      case "not handover":
        return "device-nothandover";
      default:
        return "";
    }
  };

  useEffect(() => {
    axios
      .get(apiUrl+"recovery-status")
      .then((res) => setRecoveryCounts(res.data))
      .catch((err) => console.error("Collection lead status error:", err));
}, [apiUrl]);
 const handleMapClick = () => {
    navigate("/taskmapview?page=recovery");
  };

  return (
    <div>
      <Topbar />
      <Container fluid>
        <h3 className="px-2 text-start">Recovery</h3>
       {permissions?.Recovery?.["Recovery Statistics"]?.Read && (
        <Row className="row-width">
          <Col className="dashborder mt-4 mb-5 mx-1">
            <Row className="yellow-card">
              <p className="text-center box-txt" style={{ marginTop: "15px" }}>
                Open
              </p>
            </Row>
            <Row className="number">
              <h5 className="text-center pt-2">{recoveryCounts["Open"] ?? 0}</h5>
            </Row>
          </Col>
          <Col className="dashborder mt-4 mb-5 mx-1">
            <Row className="grey-card">
              <p className="text-center box-txt">Progress</p>
            </Row>
            <Row className="number">
              <h5 className="text-center pt-1">{recoveryCounts["Progress"] ?? 0}</h5>
            </Row>
          </Col>
          <Col className="dashborder mt-4 mb-5 mx-1">
            <Row className=" green-card">
              <p className="text-center box-txt">Collected</p>
            </Row>
            <Row className="number">
              <h5 className="text-center pt-1">{recoveryCounts["Collected"] ?? 0}</h5>
            </Row>
          </Col>
          <Col className="dashborder mt-4 mb-5 mx-1">
            <Row className="purple-card row-margin">
              <p className="text-center box-txt">Out Of Station</p>
            </Row>
            <Row className="number">
              <h5 className="text-center pt-1">{recoveryCounts["Out Of Station"] ?? 0}</h5>
            </Row>
          </Col>
          <Col className="dashborder mt-4 mb-5 mx-1">
            <Row className="red-card">
              <p className="text-center box-txt">Not Handover</p>
            </Row>
            <Row className="number">
              <h5 className="text-center pt-1">{recoveryCounts["Not Handover"] ?? 0}</h5>
            </Row>
          </Col>
          <Col className="dashborder mt-4 mb-5 mx-1">
            <Row className="pink-card">
              <p className="text-center px-1 box-txt">Not Available</p>
            </Row>
            <Row className="number">
              <h5 className="text-center pt-1">{recoveryCounts["Not Available"] ?? 0}</h5>
            </Row>
          </Col>
          <Col className="dashborder mx-1 mt-4 mb-5">
            <Row className="brown-card">
              <p className="text-center box-txt">Expect Renewal</p>
            </Row>
            <Row className="number">
              <h5 className="text-center pt-1">{recoveryCounts["Expect Renewal"] ?? 0}</h5>
            </Row>
          </Col>
        </Row>
)}
        <Row className="button-bottom-custmer" xs={1} sm={2}>
          <Col className="mt-2 mb-2" md={5}>
          {permissions?.Recovery?.["Add Recovery"]?.Write && (
            <button className="black-btn btnadd black-btn1" onClick={navAddRecovery}>Add</button>
          )}
            &emsp;&emsp;
            <button
              onClick={() => window.location.reload()}
              className="black-btn black-btn1"
            >
              Refresh
            </button>
          </Col>

          <Col className="mt-2 text-end recovery-btn-2" md={6}>
          {/* <button
  className="black-btn black-btn1 btnadd"
  onClick={
    designation === "Super Admin" && filteredData.length > 0
      ? handleExportConfirmation
      : undefined
  }
  disabled={designation !== "Super Admin" || filteredData.length === 0}
  style={{
    opacity:
      designation === "Super Admin" && filteredData.length > 0 ,
    cursor:
      designation === "Super Admin" && filteredData.length > 0
        ? "pointer"
        : "not-allowed",
  }}
  title={
    designation !== "Super Admin"
      ? "Only Super Admin can export"
      : filteredData.length === 0
      ? "No data to export"
      : "Export"
  }
>
  Export
          </button> */}

            {/* <button className="black-btn black-btn1 btnadd" onClick={handleExportConfirmation}>Export</button> */}
            &emsp;&emsp;
          {permissions?.Recovery?.["Recovery Module"]?.Read && (
  <button
    className="black-btn black-btn1"
    onClick={recoverysettingPopup}
  >
    Settings
  </button>
)}
            {recoverySetting && (
              <div className="setting-popup-overlay">
                <div className="setting-popup-container">
                  <button
                    className="setting-close-btn"
                    onClick={recoverysettingPopup}
                  >
                    &times;
                  </button>
                  <div className="setting-popup-content">
                    <div className="setting-checkbox-row">
                      <label>
                        <input
                          className="checkbox-customer"
                          type="checkbox"
                          checked={Object.values(columnVisibility).every(
                            (v) => v
                          )}
                          onChange={(e) => {
                            const isChecked = e.target.checked;
                            setColumnVisibility(
                              Object.keys(columnVisibility).reduce(
                                (acc, key) => {
                                  acc[key] = isChecked;
                                  return acc;
                                },
                                {}
                              )
                            );
                          }}
                        />
                        <span
                          className="checkbox-down ms-1"
                          style={{ fontSize: "17px" }}
                        >
                          {Object.values(columnVisibility).every((v) => v)
                            ? "Unselect All"
                            : "Select All"}
                        </span>
                      </label>
                    </div>

                    <div className="setting-checkbox-grid">
                      {Object.keys(columnVisibility).map((key) => (
                        <label key={key} className="label-setting-popup">
                          <input
                            type="checkbox"
                            name={key}
                            checked={columnVisibility[key]}
                            onChange={handleColumnVisibilityChange}
                            className="checbox-popup"
                          />
                          <span className="checkbox-down1">
                            {changedata(key)}
                          </span>
                        </label>
                      ))}
                    </div>

                    <button
                      className="setting-submit-btn"
                      onClick={recoverysettingPopup}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            )}
          </Col>
           {permissions?.Recovery?.["Map View"]
                ?.Read && (
          <Col md={1}>
            <img src={Map} alt="map" style={{width:"30px",height:"30px"}}className="map-icon"
            onClick={handleMapClick}/>
          </Col>
           )}
        </Row>

        <div className="scrolltable mt-3">
            {permissions?.Recovery?.["Recovery Module"]
                ?.Read && (
          <table className="table table-bordered"  ref={tableRef}>
            <thead className="table-th text-center">
              <tr>
                {columnVisibility.customerId && (
                  <th className="table-th-content">Customer ID</th>
                )}
                {columnVisibility.leadStatus && (
                  <th className="table-th-content">Recovery Status</th>
                )}
                {columnVisibility.recoveryStartDate && (
                  <th className="table-th-content">Recovery Start Date</th>
                )}
                {columnVisibility.customerName && (
                  <th className="table-th-content">Customer Name</th>
                )}
                {columnVisibility.contactNumber && (
                  <th className="table-th-content">Contact Number</th>
                )}
                {columnVisibility.address && (
                  <th className="table-th-content">Address</th>
                )}
                {columnVisibility.location && (
                  <th className="table-th-content">Location</th>
                )}
                {columnVisibility.area && (
                  <th className="table-th-content">Area</th>
                )}
                {columnVisibility.notes && (
                  <th className="table-th-content">Notes</th>
                )}
                {columnVisibility.workStatus && (
                  <th className="table-th-content">Work Status</th>
                )}
                {columnVisibility.delete && (
                  <th className="table-th-content">Delete</th>
                )}
              </tr>
            </thead>

            <tbody className="tr:nth-child(even)">
              <tr className="search-input-box-text-center">
                {columnVisibility.customerId && (
                  <td>
                    <input
                      className="table-search background-change"
                      name="customerid"
                      onChange={handleFilterChange}
                      placeholder="Search"
                      type="text"
                    />
                  </td>
                )}
                {columnVisibility.leadStatus && (
                  <td>
                    <select
                      className="table-search background-change"
                      name="leadStatus"
                      placeholder="Search"
                      onChange={handleFilterChange}
                    >
                      <option value="">Select</option>
                      <option value="open">Open</option>
                      <option value="progress">Progress</option>
                      <option value="collected">Collected</option>
                      <option value="not available">Not Available</option>
                      <option value="out of station">Out Of Station</option>
                      <option value="expect renewal">Expect Renewal</option>
                      <option value="not handover">Not Handover</option>
                    </select>
                  </td>
                )}
                {columnVisibility.recoveryStartDate && (
                  <td>
                    <input
                      className="table-search background-change"
                      type="date"
                      style={{ textTransform: "capitalize" }}
                      name="recoveryStartDate"
                      onChange={handleFilterChange}
                      placeholder="Search"
                    />
                  </td>
                )}
                {columnVisibility.customerName && (
                  <td>
                    <input
                      className="table-search background-change"
                      type="text"
                      name="customername"
                      onChange={handleFilterChange}
                      placeholder="Search"
                    />
                  </td>
                )}
                {columnVisibility.contactNumber && (
                  <td>
                    <input
                      className="table-search background-change"
                      style={{ textTransform: "capitalize" }}
                      name="contactnum"
                      onChange={handleFilterChange}
                      placeholder="Search"
                      type="tel"
                    />
                  </td>
                )}
                {columnVisibility.address && (
                  <td>
                    <input
                      className="table-search background-change"
                      name="address"
                      onChange={handleFilterChange}
                      placeholder="Search"
                      type="text"
                    />
                  </td>
                )}
                {columnVisibility.location && (
                  <td>
                    <input
                      className="table-search background-change"
                      name="location"
                      onChange={handleFilterChange}
                      placeholder="Search"
                      type="text"
                    />
                  </td>
                )}
                {columnVisibility.area && (
                  <td>
                    <input
                      className="table-search background-change"
                      name="area"
                      onChange={handleFilterChange}
                      placeholder="Search"
                      type="text"
                    />
                  </td>
                )}
                {columnVisibility.notes && (
                  <td>
                    <input
                      className="table-search background-change"
                      name="recoverynotes"
                      onChange={handleFilterChange}
                      placeholder="Search"
                      type="text"
                    />
                  </td>
                )}
                {columnVisibility.workStatus && (
                  <td>
                    <select
                      className="table-search background-change"
                      name="workStatus"
                      onChange={handleFilterChange}
                      placeholder="Search"
                    >
                      <option value="">Select</option>
                      <option value="open">Open</option>
                      <option value="progress">Progress</option>
                      <option value="completed">Completed</option>
                      <option value="not available">Not Available</option>
                    </select>
                  </td>
                )}
                {columnVisibility.delete && <td></td>}
              </tr>

              {filteredData.length === 0 ? (
                <tr>
                  <td colSpan={Object.values(columnVisibility).filter(v => v).length} style={{ textAlign: "center" }}>
                    No data found
                  </td>
                </tr>
              ) : (
                filteredData.map((d, i) => (
                  <tr key={i}>
                  {columnVisibility.customerId && (
  <td
    onClick={() =>
      permissions?.Recovery?.["Recovery Module"]?.Write &&
      handleViewRecovery(d.customerid, d._id)
    }
    style={{
      cursor: permissions?.Recovery?.["Recovery Module"]?.Write
        ? "pointer"
        : "not-allowed",
      color: permissions?.Recovery?.["Recovery Module"]?.Write
        ? "inherit"
        : "gray",
    }}
  >
    {d.customerid}
  </td>
)}
                    {columnVisibility.leadStatus && (
                      <td>
                        <span className={getReoveryStatusClass(d.leadStatus)}>
                          {d.leadStatus}
                        </span>
                      </td>
                    )}
                    {columnVisibility.recoveryStartDate && (
                      <td>{formatDateTime(d.createdDate)}</td>
                    )}
                    {columnVisibility.customerName && <td>{d.customername}</td>}
                    {columnVisibility.contactNumber && <td>{d.contactnum}</td>}
                    {columnVisibility.address && <td>{d.address}</td>}
                    {columnVisibility.location && (
                      <td>
                        {d.location?.latitude 
                          ? ` ${d.location.latitude}, ${d.location.longitude}`
                          : "N/A"}
                      </td>
                    )}
                    {columnVisibility.area && <td>{d.area}</td>}
                    {columnVisibility.notes && (
                      <td className="table-td-content">
                        {d.recoveryleadStatus?.recoverynotes || ""}
                      </td>
                    )}
                    {columnVisibility.workStatus && <td>{d.workStatus}</td>}
                   
                    {columnVisibility.delete && (
                      <td>
                          {permissions?.Recovery?.["Recovery Module"]?.Delete ? (
                         <button className="deletebtn text-center">
                          <MdDelete 
                            size={20} 
                            onClick={() => recoveryHandleDelete(d._id)}
                          />
                        </button>
                     ):(
                         <button className="deletebtn text-center" disabled style={{ opacity: 0.5, cursor: "not-allowed",textAlign: "center"   }}>
                        <MdDelete size={20} />
                         </button>
                     )}
                     
                      </td>
                    )}
                  </tr>
                ))
              )}
            </tbody>
          </table>
             )}
        </div>
      </Container>
    </div>
  );
};

export default Recovery;